import type { ReactNode } from "react"
import Link from "next/link"

import { getAffLink } from "@/lib/aff-link"
import { getBannerLink, type SiteBanner } from "@/lib/banners"

export default function BannerLink({
  banner,
  active,
  index,
  userId,
  children,
}: {
  banner: SiteBanner
  active: boolean
  index: number
  userId?: string
  children: ReactNode
}) {
  const link = getBannerLink(banner)
  const className =
    "relative block h-full w-full focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[#0F9E4F]"
  if (!link) return <div className={className}>{children}</div>
  const props = {
    href: link.external ? getAffLink(link.href, userId) : link.href,
    className,
    tabIndex: active ? 0 : -1,
    "aria-label": `View featured offer ${index + 1}`,
  }
  return link.external ? (
    <a {...props} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <Link {...props}>{children}</Link>
  )
}
